import { ColumnDef, createColumnHelper } from "@tanstack/react-table";
import Badge from "components/base/Badge";
import AdvanceTable from "components/base/AdvanceTable";
import AdvanceTableFooter from "components/base/AdvanceTableFooter";
import { CaixaTableType } from "data/caixa";
import { format } from "date-fns";

const columnHelper = createColumnHelper<CaixaTableType>();

export const caixaTableColumns: ColumnDef<CaixaTableType>[] = [
  {
    accessorKey: "terminalCodigo",
    header: "Terminal",
    meta: {
      headerProps: { style: { width: 50 } },
      cellProps: {
        className: "fs-9 fw-semibold text-body-tertiary text-opacity-85",
      },
    },
  },
  {
    accessorKey: "numero",
    header: "Número",
    meta: {
      headerProps: { style: { width: 100 }, className: "ps-4" },
      cellProps: {
        className: "fs-9 fw-semibold ps-4 text-body-tertiary text-opacity-85",
      },
    },
  },
  {
    accessorKey: "razaoSocial",
    header: "Empresa",
    cell: ({ row: { original } }) => {
      return <Badge variant="tag">{original.razaoSocial}</Badge>;
    },
    meta: {
      headerProps: { style: { width: 150 } },
      cellProps: {
        className: "fs-9 fw-semibold text-body-tertiary text-opacity-85",
      },
    },
  },
  {
    accessorKey: "abertura",
    header: "Data de Abertura",
    cell: ({ row: { original } }) => {
      return format(new Date(original.abertura), 'dd/MM/yyyy HH:mm:ss');
    },
    meta: {
      headerProps: { style: { width: 200 } },
    },
  },
  {
    accessorKey: "fechamento",
    header: "Data de Fechamento",
    cell: ({ row: { original } }) => {
      return original.fechamento
        ? format(new Date(original.fechamento), 'dd/MM/yyyy HH:mm:ss')
        : "N/A";
    },
    meta: {
      headerProps: { style: { width: 200 } },
    },
  },
  {
    accessorKey: "saldo",
    header: "Saldo",
    cell: ({ row: { original } }) => {
      //se o saldo for positivo, exibe em verde, se for negativo, exibe em vermelho
      const saldo = original.saldo;
      return (
        <span
          style={{
            color: saldo >= 0 ? "green" : "red",
          }}
        >
          {saldo.toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
          })}
        </span>
      );
    },
    meta: {
      headerProps: { style: { width: 200 } },
    },
  },
  {
    accessorKey: "status",
    header: "Status",
    cell: ({ row }) => {
      const fechamento = row.original.fechamento;
      return fechamento === null ? (
        <Badge bg="success">Aberto</Badge>
      ) : (
        <Badge bg="danger">Fechado</Badge>
      );
    },
    meta: {
      headerProps: { style: { width: 100 } },
    },
  },
];

const CaixaTable = () => {
  return (
    <div>
      <AdvanceTable tableProps={{ className: "phoenix-table fs-9" }} />
      <AdvanceTableFooter pagination showViewAllBtn={false} />
    </div>
  );
};

export default CaixaTable;
